import { render, staticRenderFns } from "./AtomBulletSpecs.vue?vue&type=template&id=1ef87917&"
import script from "./AtomBulletSpecs.vue?vue&type=script&lang=js&"
export * from "./AtomBulletSpecs.vue?vue&type=script&lang=js&"
import style0 from "./AtomBulletSpecs.vue?vue&type=style&index=0&id=1ef87917&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
